import { render, staticRenderFns } from "./cateDialog.vue?vue&type=template&id=8b262416&scoped=true&"
import script from "./cateDialog.vue?vue&type=script&lang=js&"
export * from "./cateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b262416",
  null
  
)

export default component.exports